/**
 * Contacts Service - Gerenciamento de contatos e tags
 */

import { api } from '@/lib/api';
import {
  ContactResponse,
  UpdateContactRequest,
} from '@troia-v3/types';

export interface ContactsListResponse {
  data: ContactResponse[];
  total: number;
  page: number;
  totalPages: number;
}

/**
 * Buscar contato por ID
 */
export const getContactById = async (contactId: string): Promise<ContactResponse> => {
  const response = await api.get(`/contacts/dropdown/${contactId}`);
  return response.data.data;
};

/**
 * Atualizar tags do contato
 */
export const updateContactTags = async (
  contactId: string,
  tags: string[]
): Promise<ContactResponse> => {
  const updateData: UpdateContactRequest = {
    tags,
  };

  const response = await api.put(`/contacts/${contactId}`, updateData);
  return response.data.data;
};

/**
 * Buscar todas as tags únicas usadas no sistema
 * Usa endpoint dedicado do backend para agregação eficiente via MongoDB
 */
export const getAvailableTags = async (): Promise<string[]> => {
  const response = await api.get('/contacts/tags');
  return response.data.data;
};

/**
 * Só as tags do contato (C8). Antes o header baixava o contato INTEIRO por
 * `GET /contacts/dropdown/:id` só pra desenhar dois chips, a cada conversa
 * aberta. Rota sem permissionMiddleware, igual à vizinha.
 */
export async function getContactTags(contactId: string): Promise<string[]> {
  const response = await api.get(`contacts/dropdown/${contactId}/tags`);
  return response.data.data.tags;
}
